import React, { useState } from 'react'
import { Box, Button, Grid, Typography,Switch, FormControlLabel, Dialog} from '@mui/material'
import buttonStyle from '../../../styles/buttonStyle'
import AddIcon from '@mui/icons-material/Add';
import { DataGrid, GridColumnMenu } from '@mui/x-data-grid';
import dataGridStyle from '../../../styles/dataGridStyle';
import ActionButtons from '../../../components/ActionButtons';
import { useNavigate } from 'react-router-dom';
import AllEnquiry from './AllEnquiry';
import CalculateIcon from '@mui/icons-material/Calculate';
import Avatar from '@mui/material/Avatar';
// import { makeStyles, Dialog } from '@material-ui/core';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import ChatJob from '../Cashjob/ChatJob';

const avatarStyle = {
  display: 'flex',
  width: '50px',
  height: '50px',
  bgcolor: '#c8e6c9',
};
// const useStyles = makeStyles({
//   dialog: {
//     position: 'absolute',
//     right: 10,
//     // left: 100,
//     top: 60,
//     width:400
//   }
// });
function CustomColumnMenu(props) {
  return (
    
    <GridColumnMenu
      {...props}
      slots={{
     // Hide `columnMenuColumnsItem`
      columnMenuColumnsItem: null,
      columnMenuSortItem: null,
      }}
    />
    
);
}
const columns = [

  { field: 'EnquiryNo', headerName: 'No', editable: false, sortable: false, minWidth: 100 }, 
  { field: 'EnquiryDate', headerName: 'Date', editable: false, sortable: false, minWidth: 100}, 
  { field: 'Customer', headerName: 'Customer', editable: false, sortable: false, flex: 1, minWidth: 100 }, 
  { field: 'Address', headerName: 'Address', editable: false, sortable: false, flex: 1, minWidth: 100 },
  { field: 'Street_Name', headerName: 'Street Name', editable: false, sortable: false, flex: 1, minWidth: 100 },
  { field: 'Post_Code', headerName: 'Post Code', editable: false, sortable: false, minWidth: 100 },
  { field: 'Mob_No', headerName: 'Mobile No', editable: false, sortable: false, flex: 1 , minWidth: 100},
  { field: 'Email', headerName: 'Email', editable: false, sortable: false, flex: 1 , minWidth: 100},
  { field: 'VehicleNumber', headerName: 'VRM ', editable: false, sortable: false, minWidth: 100}, 
  { field: 'VehicleModel', headerName: 'Vehicle Model', editable: false, sortable: false, flex: 1, minWidth: 100 }, 
  { field: 'enstatus', headerName: 'Status', editable: false, sortable: false, minWidth: 100}, 
  { field: 'action', headerName: 'Actions', sortable: false, flex: 1, minWidth: 110, 
    renderCell: (params) => { 
      return ( 
        <ActionButtons title='Convert To Estimate' status={params.row.enstatus==='Enquiry'?true:false} page={`estimate_task/${params.row.EnquiryNo}`}/>
      );
     } 
  } 
  ];
   
  const rows = [
  
  { EnquiryNo: 1231, EnquiryDate: '01-01-2023', Customer: 'Oliver Jake Jack Connor',Address:'Royal Oak House Greenfield Rd, Greenfield Holywell',Street_Name:'Royal Oak House ',Post_Code:' CH8 7QB',Email :'emmamoore@gamil.com',Mob_No:'731-487-0128',  VehicleModel: 'BmwToyota Fortune', VehicleNumber:'KZ66 ZYT', enstatus:'Reject' }, 
  { EnquiryNo: 1232, EnquiryDate: '05-02-2023', Customer: 'John Fitzgerald Kennedy',Address:'28 Springfield Close Pevensey ,UK',Street_Name:'Springfield Close',Post_Code:' BN24 5JG',Email :'joshuabullen@gmail.com',Mob_No:'850-585-7045', VehicleModel: 'Tata Nexon', VehicleNumber:'OZ70 ZEV', enstatus:'Estimate' },
  { EnquiryNo: 1233, EnquiryDate: '10-03-2023', Customer: 'Alexander Anthony Benjamin',Address:'40 Longwall Road Pontefract,UK',Street_Name:'Longwall Road',Post_Code:' WF8 4SW',Email :'andrewmtt@gmail.com',Mob_No:'334-741-0808', VehicleModel: 'Hyundai Creta', VehicleNumber:'PZ65 PWO', enstatus:'Reject' },  
  { EnquiryNo: 1234, EnquiryDate: '15-04-2023', Customer: 'Liam John Mason Robert',Address:'Royal Oak House Greenfield Rd, Greenfield Holywell',Street_Name:'Royal Oak House ',Post_Code:' CH8 7QB',Email :'emmamoore@gamil.com',Mob_No:'731-487-0128',  VehicleModel: 'Lamborghini', VehicleNumber:'HZ13 WDD', enstatus:'Reject' }, 
  { EnquiryNo: 1235, EnquiryDate: '20-05-2023', Customer: 'Christopher Dominic Gabriel',Address:'40 Longwall Road Pontefract,UK',Street_Name:'Longwall Road',Post_Code:' WF8 4SW',Email :'andrewmtt@gmail.com',Mob_No:'334-741-0808', VehicleModel: 'Mitsubishi', VehicleNumber:'PZ65 BYV', enstatus:'Estimate' },
  { EnquiryNo: 1236, EnquiryDate: '21-06-2023', Customer:'James Anderson',Address:'18 Sprint Street Paddington London ',Street_Name:'Sprint Street' ,Post_Code:'W23RA',Email :'jamesjj@gmail.com',Mob_No:'334-707-9993',VehicleModel: 'BmwToyota Fortune', VehicleNumber:'KZ66 ZYT', enstatus:'Enquiry'},
  { EnquiryNo: 1237, EnquiryDate: '11-07-2023', Customer:'Antony Wilson',Address:'38b Denmead Road Bournemouth',Street_Name:'Denmead Road',Post_Code:' BH6 5QH',Email :'antonyw@gamil.com',Mob_No:'407-603-5073',VehicleModel: 'Tata Nexon', VehicleNumber:'OZ70 ZEV', enstatus:'Estimate'},
  { EnquiryNo: 1238, EnquiryDate: '25-08-2023', Customer:'Emma Moore',Address:'Royal Oak House Greenfield Rd, Greenfield Holywell',Street_Name:'Royal Oak House ',Post_Code:' CH8 7QB',Email :'emmamoore@gamil.com',Mob_No:'731-487-0128', VehicleModel: 'Hyundai Creta', VehicleNumber:'PZ65 PWO', enstatus:'Enquiry'},
  { EnquiryNo: 1239, EnquiryDate: '30-09-2023', Customer:'Andrew Moffatt',Address:'40 Longwall Road Pontefract,UK',Street_Name:'Longwall Road',Post_Code:' WF8 4SW',Email :'andrewmtt@gmail.com',Mob_No:'334-741-0808',VehicleModel: 'Lamborghini', VehicleNumber:'HZ13 WDD', enstatus:'Enquiry'},
  { EnquiryNo: 1240, EnquiryDate: '15-10-2023', Customer:'Jade Mccheyne',Address:'70 Knowles Street Radcliffe,Manchester ',Street_Name:'Knowles Street',Post_Code:'M26 4DT',Email :'mccheynejade@gmail.com',Mob_No:'615-829-2259', VehicleModel: 'Hyundai Creta', VehicleNumber:'PZ65 PWO', enstatus:'Enquiry'},
  { EnquiryNo: 1241, EnquiryDate: '10-11-2023', Customer:'Bradley O connell',Address:'11 Manor Crescent Carmarthen,UK',Street_Name:'Manor Crescent',Post_Code:' SA31 3RJ', Email :'oconnel12@gmail.com',Mob_No:'404-805-9531',VehicleModel: 'Lamborghini', VehicleNumber:'HZ13 WDD', enstatus:'Enquiry'},
  { EnquiryNo: 1242, EnquiryDate: '25-12-2023', Customer:'Gareth Walker',Address:'6 Florence Way Peterborough,UK',Street_Name:'Florence Way',Post_Code:' PE6 8PG',Email :'garethwalker@gmail.com',Mob_No:'615-829-2259',VehicleModel: 'Tata Nexon', VehicleNumber:'OZ70 ZEV', enstatus:'Estimate'},
  { EnquiryNo: 1243, EnquiryDate: '11-01-2023', Customer:'Craig Rice',Address:'29 Queens Drive Stranraer UK',Street_Name:' Queens Drive',Post_Code:'DG9 0DH',Email :'craigr12@gmail.com',Mob_No:'832-782-3213', VehicleModel: 'Hyundai Creta', VehicleNumber:'PZ65 PWO', enstatus:'Enquiry'},
  { EnquiryNo: 1244, EnquiryDate: '21-02-2023', Customer:'Paul McCann',Address:'23 Burns Place Shotts,UK',Street_Name:'Burns Place',Post_Code:'ML7 4LQ',Email :'paulcann@gmail.com',Mob_No:'678-880-7131',VehicleModel: 'Tata Nexon', VehicleNumber:'OZ70 ZEV', enstatus:'Estimate' },
  { EnquiryNo: 1245, EnquiryDate: '12-03-2023', Customer:'Joshua Bullen',Address:'28 Springfield Close Pevensey ,UK',Street_Name:'Springfield Close',Post_Code:' BN24 5JG',Email :'joshuabullen@gmail.com',Mob_No:'850-585-7045',VehicleModel: 'Tata Nexon', VehicleNumber:'OZ70 ZEV', enstatus:'Estimate'},

  ];
  
function Enquiry() {
  // const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const navigate = useNavigate()
  const [isAllData, setIsAllData] = useState(false)
  const pageChange = (e) => { {setIsAllData(e.target.checked)}};
return (
  <Box mt={2}>
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <Grid container spacing={1}>
          <Grid item xs={8}>
            <Typography sx={{ fontWeight: "bold", fontSize: "18px" }}>
              ENQUIRY DETAILS
            </Typography>
          </Grid>
          <Grid item xs={2}>
              <Box display="flex" justifyContent="flex-end" sx={{mt:'5px'}}>
                <span>Pending</span>
                <FormControlLabel
                  sx={{ marginLeft: "20px" }}
                  control={<Switch size="small" color="success" checked={isAllData} onChange={pageChange}/>}                  
                />
                <span>All Data</span>
              </Box>
          </Grid>
          <Grid item xs={2} display="flex" justifyContent="flex-end">
            <Button
              sx={buttonStyle.root}
              onClick={() => navigate("/add_enquiry")}
            >
              <AddIcon />
              Add Enquiry
            </Button>
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={12} mt={1}>
       {!isAllData && 
        <Box sx={dataGridStyle.root} >
        <DataGrid
          columnHeaderHeight={42}
          rowHeight={40}
          rows={rows.filter(item => item.enstatus === 'Enquiry')}
          columns={columns}
          getRowId={(row) => row.EnquiryNo}
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 20,
              },
            },
          }}
          pageSizeOptions={[20]}
          slots={{ columnMenu: CustomColumnMenu }}
          disableRowSelectionOnClick
        />
      </Box>
       }
       {isAllData && <AllEnquiry columns={columns} rows={rows}/>}
      </Grid>

      <Grid item xs={12} display='flex' justifyContent='flex-end' mt={15}>
        <Box mt={2} >
          <Grid container spacing={1} >
            <Grid item xs={12} >
              <div>
                <Avatar sx={avatarStyle}>
                  <CalculateIcon sx={{color:'#66bb6a'}} onClick={handleClickOpen}/>
                </Avatar>
                <Dialog
                  open={open}
                  onClose={handleClose}
                  aria-labelledby="alert-dialog-title"
                  aria-describedby="alert-dialog-description"
                  sx={{ position: 'absolute',
                      // right: 10,
                      left: 1050,
                      top: 60,
                      width:450
                    }}
                  // classes={{
                  // paper: classes.dialog
                  //  }}
                   >
                  <DialogContent>
                    <ChatJob/>
                  </DialogContent>
                  <DialogActions>
                    <Button sx={buttonStyle.root} onClick={handleClickOpen}> {" "} Save{" "} </Button> &nbsp;
                    <Button sx={buttonStyle.root} onClick={handleClose}  > {" "} Cancel{" "} </Button>
                  </DialogActions>
                </Dialog>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Grid>
    </Grid>
  </Box>
);
}

export default Enquiry